import React, { useState } from "react";
import PropTypes from "prop-types";

// QueueContext
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout";

// styles
import { AddTagStyled, InputWithIconWrapperStyled } from "./styles.js";

// components
import Tag from "core/ReusableIcons/Tag.js";
import Button from "core/Button";
import { InputWithIcon } from "core/FormControls";

const AddTag = ({ onTagAdd }) => {
    // state/context
    const {
        state: { singleUploadSelected },
        selectedBatchObj
    } = useQueueContext();
    const [tagName, tagNameUpdate] = useState("");

    const handleTagAdd = () => {
        onTagAdd({ uploadId: singleUploadSelected.id, newTagName: tagName });
    };

    const onChange = e => {
        tagNameUpdate(e.target.value);
    };

    if (!selectedBatchObj.isEditable.flags) return null;

    return (
        <AddTagStyled>
            <InputWithIconWrapperStyled>
                <InputWithIcon
                    onChange={onChange}
                    value={tagName}
                    controlId={`add-tag-sidebar`}
                    placeholder="Add tag"
                >
                    <Tag size={{ width: 14, height: 14 }} />
                </InputWithIcon>
            </InputWithIconWrapperStyled>
            <div>
                <Button size="sm" onClick={handleTagAdd}>
                    Add
                </Button>
            </div>
        </AddTagStyled>
    );
};

export default AddTag;

// prop-types
AddTag.propTypes = {
    onTagAdd: PropTypes.func.isRequired
};
